import * as React from "react";
import { useSelector } from "react-redux";
import { StudentService } from "../../components/studentService";
import { ChatRoomModel } from "./ChatRoomModel.js";
import { ChatRoomView } from "./ChatRoomView.jsx";
import { Config } from "../../../personal-studio-components/service/Config.js";
import axios from "axios";

export { ChatRoom, ChatRoomModel, ChatRoomView };
/**
 * Контроллер диалога "Чатрум" на странице "Консультации".
 * @param {Object} props - Атрибуты компонента.
 * @param {integer} props.question_tutor_id -
 * Идентификатор вопроса преподавателю.
 * @param {EventListener} onClose - Действие при закрытии.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function ChatRoom({ question_tutor_id, onClose }) {
  // Начальное состояние
  const { contractId } = useSelector((state) => state.contract);
  const { access_token } = useSelector((state) => state.token);
  const [response, setResponse] = React.useState(null);
  const [student_service_url, setStudent_service_url] = React.useState("");
  const [progress, setProgress] = React.useState(0);
  const [errorFiles, setErrorFiles] = React.useState(null);

  const model = new ChatRoomModel({
    env: {
      access_token,
      study_contract_id: contractId,
      question_tutor_id,
    },
    onClose,
    onSubmit,
  });
  // Отправка запроса
  const request = model.getRequest();
  React.useEffect(() => {
    if (question_tutor_id) StudentService.send(request, setResponse);
  }, [question_tutor_id]);
  React.useEffect(() => {
    async function getConfig() {
      await Config.load();
      const student_service = Config.get("student_service");
      setStudent_service_url(student_service);
    }
    getConfig();
  }, []);

  // Отображение компонента
  if (!question_tutor_id) return null;
  if (!response)
    return <ChatRoomView.LoaderView title={model.title} onClose={onClose} />;
  if (response.errors)
    return (
      <ChatRoomView.ErrataView
        title={model.title}
        errata={response}
        onClose={onClose}
      />
    );
  model.parseResponse(response);
  return (
    <ChatRoomView
      model={model}
      progress={progress}
      student_service_url={student_service_url}
      errorFiles={errorFiles}
      setErrorFiles={setErrorFiles}
    />
  );
  // Обработка событий
  async function onSubmit(data) {
    setProgress(0);
    delete data.sending;
    try {
      await axios.post(
        student_service_url + "/student/question_tutor/add",
        {
          ...data,
          access_token,
          study_contract_id: contractId,
          question_tutor_id,
        },
        {
          onUploadProgress: (progressEvent) => {
            setProgress(Math.round(progressEvent.progress * 100));
          },
        }
      );

      StudentService.send(request, setResponse);
      onClose({});
    } catch (error) {
      if (error.response.data.error_type === "file_group") {
        setErrorFiles(error.response.data.errors);
        return;
      }
      console.log("Ошибка при отправке данных:", error);
    }

    // const submit = model.getSubmitRequest(data);
    // StudentService.submit(submit, request, setResponse);
  }
}
